import { Role } from 'constants/roles';

import { useApiContext } from 'context/apiContext';
import { usePermissions } from 'hooks/usePermissions';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Tab, useShowController } from 'react-admin';
import { ShowPageTabbed } from 'shared/react-admin/Pages';
import { Order } from 'types/embedded/order';

import { OrdersShowCommonInfo } from './OrdersShowCommonInfo/OrdersShowCommonInfo';
import { OrdersShowCustomData } from './OrdersShowCustomData/OrdersShowCustomData';
import { OrdersShowDisputes } from './OrdersShowDisputes/OrdersShowDisputes';
import { OrdersShowLogs } from './OrdersShowLogs/OrdersShowLogs';
import { OrdersShowNotifications } from './OrdersShowNotifications/OrdersShowNotifications';

export const OrdersShow = () => {
  const translate = useTypedTranslate();

  const { record } = useShowController<Order>();
  const { user } = useApiContext();
  const { hasResourceAccess } = usePermissions();

  return (
    <ShowPageTabbed
      headerTitle={{
        titleText: translate('app.orders.orderNum', { originId: record?.originId || '' }),
      }}
      listName={translate('app.orders.orders')}
      title={translate('app.orders.orderDetails')}
    >
      <Tab label={translate('app.orders.info')}>
        <OrdersShowCommonInfo />
      </Tab>

      {!user.roles.includes(Role.Observer) && (
        <Tab label={translate('app.orders.addInfo')}>
          <OrdersShowCustomData />
        </Tab>
      )}
      {!user.roles?.some((role) => [Role.Observer, Role.Risk].includes(role)) && (
        <Tab label={translate('app.common.notifications')}>
          <OrdersShowNotifications />
        </Tab>
      )}
      {hasResourceAccess('order_events') && (
        <Tab label={translate('app.common.requestLogs')}>
          <OrdersShowLogs />
        </Tab>
      )}
      {hasResourceAccess('order_disputes') && (
        <Tab label="Диспуты">
          <OrdersShowDisputes />
        </Tab>
      )}
    </ShowPageTabbed>
  );
};
